import { FunctionComponent, useMemo } from 'react';
import './styles/ScheduleTableFilters.scss';

import { Select } from './core/Select';
import { IOptionsItem, IScheduleTableFilters, SCHEDULE_MODE, SCREEN_SIZE, DAY_OF_WEEK, DANCE_STYLE } from '../models';
import { classNames, splitByUpperCase } from '../utils';

interface IScheduleTableFiltersProps {
  filters: IScheduleTableFilters;
  filtersChanged: (filters: IScheduleTableFilters) => void;
  screenSize: SCREEN_SIZE;
  mode: SCHEDULE_MODE;
  disabled?: boolean;
}
export const ScheduleTableFilters: FunctionComponent<IScheduleTableFiltersProps> = (props: IScheduleTableFiltersProps) => {

  const {
    filters,
    filtersChanged,
    screenSize,
    mode,
    disabled
  } = props;

  const ageOptions = useMemo(() => {
    const standardAges = Array.from({ length: 18 }, (_, index) => ({
      value: (index + 1).toString()
    }) as IOptionsItem);

    if (filters.age && !standardAges.some(x => x.value === filters.age)) {
      standardAges.push({ value: filters.age });
    }
    return standardAges;
  }, [filters.age]);

  const handleStyleFilterChanged = (val: IOptionsItem | null) => {
    const updatedFilters: IScheduleTableFilters = {
      ...filters,
      style: val?.value ?? ''
    };
    filtersChanged(updatedFilters);
  };

  const handleDayOfWeekFilterChanged = (val: IOptionsItem | null) => {
    const updatedFilters: IScheduleTableFilters = {
      ...filters,
      dayOfWeek: val?.value ?? ''
    };
    filtersChanged(updatedFilters);
  };

  const handleAgeFilterChanged = (val: IOptionsItem | null) => {
    const updatedFilters: IScheduleTableFilters = {
      ...filters,
      age: val?.value ?? ''
    };
    filtersChanged(updatedFilters);
  };

  return (
    <div className={classNames('ppa-schedule-table-filters', screenSize)}>
      <div className='title-wrapper'>
        {mode === SCHEDULE_MODE.ENROL ? (
          <h2>Select Classes to Enrol in</h2>
        ) : mode === SCHEDULE_MODE.TRIAL ? (
          <h2>Select Classes to Trial</h2>
        ) : null}
      </div>
      <div className='filters-wrapper'>
        <Select
          label='Style'
          options={Object.values(DANCE_STYLE).map(x => ({
            value: x,
            label: splitByUpperCase(x)
          }))}
          value={filters.style}
          onChange={handleStyleFilterChanged}
          minWidth='190px'
          disabled={disabled}
        />

        <Select
          label='Age'
          options={ageOptions}
          value={filters.age}
          onChange={handleAgeFilterChanged}
          minWidth='190px'
          disabled={disabled}
        />

        <Select
          label='Day of Week'
          options={Object.values(DAY_OF_WEEK).map(x => ({
            value: x
          }))}
          value={filters.dayOfWeek}
          onChange={handleDayOfWeekFilterChanged}
          minWidth='190px'
          disabled={disabled}
        />
      </div>
    </div>
  )
}